import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import styles from './styles.m.scss';
import star from '../../../images/afcpe-star.png';

const propTypes = {
  className: PropTypes.string,
  percent: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

const EngagmentMeter = ({ className, percent }) => {
  return (
    <div className={cn(styles.meterWrapper, 'mb-3')}>
      <div className={cn(styles.meter, className)}>
        <div className={styles.filled} style={{ height: `${percent}%` }} />
        <img alt="Sage Financial Solutions" src={star} />
      </div>
    </div>
  );
};

EngagmentMeter.propTypes = propTypes;

export default EngagmentMeter;
